import React, { createContext, useCallback, useContext, useEffect, useReducer } from 'react';
import { trackAnalyticsEvent } from '../utils/analytics';

const CartContext = createContext();

const cartReducer = (state, action) => {
  console.log('Dispatch called:', action);
  switch (action.type) {
    case 'ADD_ITEM':
      // Check if the item with the same id and selectedColor is already in the cart
      const existingItemIndex = state.findIndex((item) => {
        if (item.itemKey || action.payload.itemKey) {
          return item.itemKey === action.payload.itemKey;
        }
        return item.id === action.payload.id && item.selectedColor === action.payload.selectedColor;
      });

      if (existingItemIndex >= 0) {
        // If the item exists, update its quantity
        const updatedCart = [...state];
        updatedCart[existingItemIndex].quantity += action.payload.quantity;
        return updatedCart;
      }

      // If the item does not exist, add it as a new entry
      return [...state, action.payload];

    case 'INCREASE_QUANTITY':
      return state.map(item =>
        (action.payload.itemKey
          ? item.itemKey === action.payload.itemKey
          : item.id === action.payload.id && item.selectedColor === action.payload.selectedColor)
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );

    case 'DECREASE_QUANTITY':
      return state.map(item =>
        (action.payload.itemKey
          ? item.itemKey === action.payload.itemKey
          : item.id === action.payload.id && item.selectedColor === action.payload.selectedColor)
          ? { ...item, quantity: Math.max(1, item.quantity - 1) }
          : item
      );

    case 'REMOVE_ITEM':
      return state.filter((item) => (
        action.payload.itemKey
          ? item.itemKey !== action.payload.itemKey
          : !(item.id === action.payload.id && item.selectedColor === action.payload.selectedColor)
      ));
    case 'CLEAR_CART':
      return [];

    default:
      return state;
  }
};


export const CartProvider = ({ children }) => {
  const [cart, dispatchCart] = useReducer(cartReducer, [], () => {
    if (typeof localStorage === 'undefined') return [];
    try {
      const saved = localStorage.getItem('cart');
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.warn('Failed to parse cart from localStorage:', error);
      return [];
    }
  });

  const dispatch = useCallback((action) => {
    dispatchCart(action);
    if (action.type === 'ADD_ITEM') {
      trackAnalyticsEvent('add_to_cart', {
        productId: action.payload.id,
        quantity: action.payload.quantity,
      });
    } else if (action.type === 'REMOVE_ITEM') {
      const item = cart.find((entry) => action.payload.itemKey
        ? entry.itemKey === action.payload.itemKey
        : entry.id === action.payload.id && entry.selectedColor === action.payload.selectedColor);
      if (item) trackAnalyticsEvent('remove_from_cart', { productId: item.id, quantity: item.quantity });
    }
  }, [cart]);

  useEffect(() => {
    try {
      localStorage.setItem('cart', JSON.stringify(cart));
    } catch (error) {
      console.warn('Failed to save cart to localStorage:', error);
    }
  }, [cart]);

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  return useContext(CartContext);
};
